import React, {useState, useContext} from 'react';
import Button from "@amzn/meridian/button";
import {FormattedMessage, injectIntl} from "react-intl";
import Row from "@amzn/meridian/row";
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import {GlobalStateContext} from "../global/context/GlobalStateContext";

const UpdateDeviceStatusModal = (props) => {

    const {formatMessage} = props.intl;
    const {open, setOpen, selected, setSelected, status, additionalConfirmationMessage, deviceLocation} = props;
    const [valueMacAddress, setValueMacAddress] = useState("");
    const {showWarning} = useContext(GlobalStateContext);
    const {showCustomAlert} = useContext(GlobalStateContext);

    const onCloseModal = () => {
        setOpen(false)
        setSelected("");
        resetInputState();
    }

    const onClickConfirm = (mac, status) => {
        showWarning(formatMessage({id: "device.editWarning"}), () => {
            updateStatus(mac, status);
            setOpen(false);
            resetInputState();
            getData();
        });
    };

    function resetInputState() {
        setValueMacAddress("");
    }

    const prefill = () => {
        if (!selected)
            return;
        setValueMacAddress(selected);
    }

    const updateStatus = (mac, status) => {
        props.dispatch({type: 'UPDATE_DEVICE_STATUS', data: {dispatcher: props.dispatch, mac: mac,
               status: status, showCustomAlert: showCustomAlert}})
    }
    const getData = () => {
        props.dispatch({type: 'LOAD_VIEW', data: {dispatcher: props.dispatch}});
    }

    if (open) {
        return (
            <Modal
                title={formatMessage({id: "device.update_device_status_button_modal"})}
                open={open}
                onOpen={prefill}
                onClose={onCloseModal}
                scrollContainer="viewport"
                closeLabel="Close"
                bodySpacingInset="medium">
                <Column spacing={"medium"} spacingInset={"medium"}>
                    {additionalConfirmationMessage && (
                        <div style={{ 
                            marginBottom: '16px', 
                            padding: '16px', 
                            backgroundColor: '#fff8e1', 
                            border: '1px solid #ffcc02',
                            borderRadius: '6px',
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '8px'
                        }}>
                            <span role="img" aria-label="Warning" style={{ fontSize: '16px', marginTop: '1px' }}>⚠️</span>
                            <Text tag="span" type="b300" style={{ 
                                color: '#b7791f',
                                fontWeight: '600',
                                lineHeight: '1.4',
                                margin: 0,
                                fontSize: '15px'
                            }}>
                                <strong>CAUTION:</strong> {additionalConfirmationMessage.replace(/^Caution:\s*/i, '')}
                            </Text>
                        </div>
                    )}
                    <Text tag="label" type="b200" color="primary" htmlFor="my-input">

                            <FormattedMessage id="modal.confirmmacstatusupdate"
                                              defaultMessage="Please confirm that you wish to change status of the following device:"/>
                    </Text>
                    <Text type={"b300"} style={{ fontSize: '14px', color: '#666' }}>
                            <strong>Controller Location:</strong> {deviceLocation ? deviceLocation : valueMacAddress}
                    </Text>
                    <Text type={"b300"} style={{ fontSize: '14px', color: '#666' }}>
                            <strong><FormattedMessage id="device.new Status"
                                              defaultMessage="New Status"/>:</strong> {status}
                    </Text>
                </Column>
                <ModalFooter>
                    <Row alignmentHorizontal="right" widths="fit">
                        <Button type="secondary" size="medium" onClick={onCloseModal}>
                            <FormattedMessage id="modal.cancel" defaultMessage="Cancel"/>
                        </Button>
                        <Button type="primary" size="medium"
                                onClick={() => onClickConfirm(valueMacAddress, status)}>
                            <FormattedMessage id="modal.confirm" defaultMessage="Confirm"/>
                        </Button>
                    </Row>
                </ModalFooter>
            </Modal>
        )
    } else {
        return null;
    }
}

export default injectIntl(UpdateDeviceStatusModal);



// WEBPACK FOOTER //
// ./src/components/commonui/UpdateDeviceStatusModal.js